import React, { useEffect, useState } from "react";
import "./UserProfile.scss";
import { updateUserInfo } from "../../services/userProfile/userProfile.services";
import { toast } from "react-toastify";
import AuthService from "../../services/authentication/auth.service";
import LocalStorageConstant from "../../constants/localStorage.constant";
interface TabsProps {
  value?: any;
}

const UserProfile: React.FC<TabsProps> = ({ value }) => {
  const [jobTitle, setJobTitle] = useState("");
  const [mobileNumber, setMobileNumber] = useState(value.mobileNumber || "");
  const [countryCodeMobile, setCountryCodeMobile] = useState("");
  const [officeNumber, setOfficeNumber] = useState("");
  const [countryCodeOffice, setCountryCodeOffice] = useState("");
  const [mobileNumberChanged, setMobileNumberChanged] = useState<boolean>(false);
  const [officeNumberChanged, setOfficeNumberChanged] =
    useState<boolean>(false);
  const [countryCodeMobileChanged, setCountryCodeMobileChanged] =
    useState<boolean>(false);
  const [countryCodeOfficeChanged, setCountryCodeOfficeChanged] =
    useState<boolean>(false);    

  const handleInputChange = (id: string, value: string) => {
  if (id === "mobileNumber") {
    setMobileNumber(value.replace(/[^\d]/g, ""));
    setMobileNumberChanged(true);
  } else if (id === "officeNumber") {
    setOfficeNumber(value.replace(/[^\d]/g, ""));
    setOfficeNumberChanged(true);
  } else if (id === "countryCodeMobile") {
    setCountryCodeMobile(value.replace(/(?!^\+)[^\d]/g, ""));
    setCountryCodeMobileChanged(true);
  } else if (id === "countryCodeOffice") {
    setCountryCodeOffice(value.replace(/(?!^\+)[^\d]/g, ""));
    setCountryCodeOfficeChanged(true);
  }
};

  useEffect(() => {
    saveUserData();
  }, []);
  
  useEffect(() => {
  const handleClickOutside = (event: MouseEvent) => {
    const formElement = document.getElementById("userProfileForm");
    if (formElement && !formElement.contains(event.target as Node)) {
      const mobileValid = mobileNumber !== "" ? /^\d{10}$/.test(mobileNumber): true;
      const officeValid = officeNumber !== "" ? /^\d{10}$/.test(officeNumber) : true;
      const mobileCodeValid = countryCodeMobile !== "" ? /^\+\d{1,3}$/.test(countryCodeMobile): true;
      const officeCodeValid = countryCodeOffice !== "" ? /^\+\d{1,3}$/.test(countryCodeOffice): true;

      if (!mobileValid){
        toast.error("Mobile number must be exactly 10 digits.");
      }
      if (!officeValid){
        toast.error("Office number must be exactly 10 digits.");
      } 
      if (!mobileCodeValid){
        toast.error("Mobile country code must start with + and have 1-3 digits.");
      } 
      if (!officeCodeValid){
        toast.error("Office country code must start with + and have 1-3 digits.");
      }
      const formValid = mobileValid && officeValid && mobileCodeValid && officeCodeValid;

      if (formValid) saveUserData();
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [mobileNumber, officeNumber, countryCodeMobile, countryCodeOffice]);

  const saveUserData = async () => {
  try {
    const request = {
      Email: value.email,
      MobileCountryCode: countryCodeMobileChanged ? countryCodeMobile : value.mobileCountryCode,
      MobileNumber: mobileNumberChanged ? mobileNumber : value.mobileNumber,
      OfficeCountryCode: countryCodeOfficeChanged ? countryCodeOffice : value.officeCountryCode,
      OfficeNumber: officeNumberChanged ? officeNumber : value.officeNumber,
    };
    const response: any = await updateUserInfo(request);
    if (response.statusCode === 200 && response.success) {
      const refresh_token = localStorage.getItem("refresh_token");
      const access_token = localStorage.getItem("access_token");

      if (!refresh_token || !access_token) {
        AuthService.logout();
        return;
      }

      const success = await AuthService.refreshTokenFromServer(refresh_token, access_token);
      if (success) {
        const user = response.data;
        const localDataString = localStorage.getItem(LocalStorageConstant.user);
        if (localDataString) {
          const localData = JSON.parse(localDataString);
          localData.user = user;
          localStorage.setItem(LocalStorageConstant.user, JSON.stringify(localData));
        }

        setMobileNumber(!user.mobileNumber ||user.mobileNumber === "undefined" || user.mobileNumber === "null" ? "" : user.mobileNumber);
        setCountryCodeMobile(!user.mobileCountryCode || user.mobileCountryCode === "undefined" || user.mobileCountryCode === "null" ? "" : user.mobileCountryCode);
        setOfficeNumber(!user.officeNumber || user.officeNumber === "undefined" || user.officeNumber === "null" ? "" : user.officeNumber);
        setCountryCodeOffice(!user.officeCountryCode || user.officeCountryCode === "undefined" || user.officeCountryCode === "null" ? "" : user.officeCountryCode);
      }
    }
  } catch (error) {
    console.error("Failed to update user profile", error);
  }
};

  return (
    <div className="min-w-full rounded-[8px] bg-darkcolor-700 outline-[1px] mb-[10px] mt-[10px]">
      <div className="card profile-card flex-grow m-0">
        <div className="flex flex-col gap-[8px]">
          <p className="title">Profile</p>
          <p className="sub-text-info">View user name and contact info.</p>
        </div>
        <div className="h-[1px] w-full bg-white opacity-20 mt-4"></div>
        <div className="body">
          <div className="profile-info">
            <div className="protext">
              <div className="text">Personal info</div>
            </div>
            <div className="card">
              <form className="register-form" id="userProfileForm">
                <div className="form-row">
                  <div className="form-col">
                    <label htmlFor="firstName" className="sub-text">
                      First name *
                    </label>
                    <div className="item-input">
                    <input
                      type="text"
                      id="firstName"
                      disabled
                      className="input-outline-4 text-disabled"
                      value={value.firstName ? value.firstName : ""}
                    />
                    </div>
                  </div>
                  <div className="form-col">
                    <label htmlFor="lastName" className="sub-text">
                      Last name *
                    </label>
                    <div className="item-input">
                    <input
                      type="text"
                      id="lastName"
                      disabled
                      className="input-outline-4 text-disabled"
                      value={value.lastName ? value.lastName : ""}
                    />
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-col">
                    <label htmlFor="company" className="sub-text">
                      User identity *
                    </label>
                    <div className="item-input">
                    <input
                      type="text"
                      id="company"
                      disabled
                      className="input-outline-4 text-disabled"
                      value="Employee"
                    />
                    </div>
                  </div>
                  <div className="form-col">
                    <label htmlFor="jobTitle" className="sub-text">
                      Operator *
                    </label>
                    <div className="item-input">
                    <input
                      type="text"
                      id="jobTitle"
                      disabled
                      className="input-outline-4 text-disabled"
                      value="ChampionX"
                    />
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-col">
                    <label htmlFor="jobTitle" className="sub-text">
                      Job title *
                    </label>
                    <div className="item-input">
                    <input
                      type="text"
                      id="jobTitle"
                      disabled
                      className="input-outline-4 text-disabled"
                      value={""}
                    />
                    </div>
                  </div>
                  <div className="form-col">
                    <label htmlFor="email" className="sub-text">
                      Email/User name *
                    </label>
                    <div className="item-input">
                      <input
                      type="email"
                      id="email"
                      disabled
                      className="input-outline-4 text-disabled"
                      value={value.email ? value.email : ""}
                    />
                    </div>
                    
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-col">
                    <label htmlFor="mobileNumber" className="sub-text">
                      Office phone number
                    </label>
                    <div className="phone-input">
                      <input
                        type="text"
                        id="countryCodeOffice"
                        className="input-outline-4 mr-[5px]"
                        value={!countryCodeOffice  || countryCodeOffice === "undefined" ? "" : countryCodeOffice}
                        onChange={(e) => {
                          setCountryCodeOffice(e.target.value);
                          handleInputChange(
                            "countryCodeOffice",
                            e.target.value
                          );
                        }}
                        style={{ backgroundColor: "#001023", width: "56px",paddingLeft: "7px" }}
                      />
                      <input
                        type="text"
                        id="officeNumber"
                        className="input-outline-4"
                        value={!officeNumber  || officeNumber === "undefined" ? "" : officeNumber}
                        onChange={(e) => {
                          setOfficeNumber(e.target.value);
                          handleInputChange("officeNumber", e.target.value);
                        }}
                        style={{ backgroundColor: "#001023", width: "450px" }}
                      />
                    </div>
                  </div>
                   <div className="form-col">
                    <label htmlFor="officeNumber" className="sub-text">
                      Mobile phone number
                    </label>
                    <div className="phone-input">
                      <input
                        type="text"
                        id="countryCodeMobile"
                        className="input-outline-4 mr-[5px]"
                        value={(!countryCodeMobile || countryCodeMobile === "undefined") ? "" : countryCodeMobile}
                        onChange={(e) => {
                          setCountryCodeMobile(e.target.value);
                          handleInputChange(
                            "countryCodeMobile",
                            e.target.value
                          );
                        }}
                        style={{ backgroundColor: "#001023", width: "56px",paddingLeft: "7px" }}
                      />
                      <input
                        type="text"
                        id="mobileNumber"
                        className="input-outline-4"
                        value={!mobileNumber || mobileNumber === "undefined" ? "" : mobileNumber}
                        onChange={(e) => {
                          setMobileNumber(e.target.value);
                          handleInputChange("mobileNumber", e.target.value);
                        }}
                        style={{ backgroundColor: "#001023", width: "450px" }}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="mt-4 flex flex-col gap-[8px]">
            <div className="h-[1px] w-full bg-white opacity-20 mt-2 mb-4"></div>
            <div className="form-row-2">
              <div className="form-col-3 measure-col">
                <div className="protext">
                  <div className="text">Unit of measure</div>
                  <p className="sub-text">
                    Pick a unit that best fits your workflow
                    <br />
                    or region.
                  </p>
                </div>
              </div>

              <div className="form-col-2">
                <label htmlFor="unit" className="sub-text">
                  Unit of measure
                </label>
                <div className="item-input">
                <input
                  type="text"
                  id="unit"
                  className="input-outline-4 text-disabled"
                  value={"Imperial"}
                  disabled
                />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
